import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';

export interface JcTextAreaProps extends JcCommonProps {
    readonly value: string;
    readonly onChange: (value: string) => void;
    readonly onEnter?: () => void;
    readonly placeholder?: string;
    readonly rows?: number;
    readonly cols?: number;
    readonly name?: string;
    readonly disabled?: boolean;
}

export const JcTextArea: React.FunctionComponent<JcTextAreaProps> = (props: JcTextAreaProps) => {
    const id = useJcFieldId(props.id);
    const commonProps = JcUtils.commonProps({ ...props, id }, ["jc-input", "jc-textarea"]);

    return (
        <textarea
            {...commonProps}
            name={props.name}
            value={props.value}
            placeholder={props.placeholder}
            rows={props.rows || 4}
            cols={props.cols || 50}
            disabled={props.disabled}
            onKeyDown={(e) => {
                if (e.key === "Enter" && e.ctrlKey && props.onEnter != null) {
                    props.onEnter();
                }
            }}
            onChange={e => props.onChange(e.target.value)}
        />
    );
};
